import { supabase } from "@/infrastructure/supabase/client";
import type { ProductKind, ProductRow } from "@/infrastructure/supabase/database.types";

export interface UpsertProductInput {
  id?: string;
  slug: string;
  name: string;
  vendor: string | null;
  kind: ProductKind;
  summary: string | null;
  homepage_url: string | null;
  notes: string | null;
  applies_to_components: string[];
}

export const productsRepository = {
  async list(): Promise<ProductRow[]> {
    const { data, error } = await supabase
      .from("products")
      .select("*")
      .order("name", { ascending: true });
    if (error) throw error;
    return data ?? [];
  },

  async getBySlug(slug: string): Promise<ProductRow | null> {
    const { data, error } = await supabase
      .from("products")
      .select("*")
      .eq("slug", slug)
      .maybeSingle();
    if (error) throw error;
    return data;
  },

  async upsert(input: UpsertProductInput): Promise<ProductRow> {
    const { data, error } = await supabase
      .from("products")
      .upsert(input, { onConflict: "slug" })
      .select("*")
      .single();
    if (error) throw error;
    return data;
  },

  async remove(id: string): Promise<void> {
    const { error } = await supabase.from("products").delete().eq("id", id);
    if (error) throw error;
  },
};
